class HomePopupElement extends HTMLElement {
  connectedCallback() {
    this.mask = this.querySelector('[data-home-popup-mask]');
    this.dialog = this.querySelector('[data-home-popup-dialog]');
    this.closeButton = this.querySelector('[data-home-popup-close]');

    if (!this.dialog) {
      return;
    }

    this.storageKey = this.dataset.storageKey;
    this.expiresMs = Number(this.dataset.expiresMs || 0);

    this.handleMaskClick = () => this.hide();
    this.handleCloseClick = () => this.hide();
    this.handleKeyUp = (event) => {
      if (event.key === 'Escape') {
        this.hide();
      }
    };

    this.listenerOptions = { passive: true };

    this.addEventListeners();

    if (this.shouldDisplay()) {
      this.show();
    } else {
      this.hide(true);
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.mask?.addEventListener('click', this.handleMaskClick);
    this.closeButton?.addEventListener('click', this.handleCloseClick);
    document.addEventListener('keyup', this.handleKeyUp, this.listenerOptions);
  }

  removeEventListeners() {
    this.mask?.removeEventListener('click', this.handleMaskClick);
    this.closeButton?.removeEventListener('click', this.handleCloseClick);
    document.removeEventListener('keyup', this.handleKeyUp, this.listenerOptions);
  }

  shouldDisplay() {
    if (!this.storageKey) {
      return true;
    }

    const storedValue = window.localStorage.getItem(this.storageKey);

    if (!storedValue) {
      return true;
    }

    if (!this.expiresMs) {
      return false;
    }

    try {
      const { closedAt } = JSON.parse(storedValue);
      if (!closedAt) {
        return true;
      }

      return Date.now() - Number(closedAt) > this.expiresMs;
    } catch (error) {
      console.warn('[home-popup] failed to parse stored state', error);
      return true;
    }
  }

  show() {
    this.hidden = false;
    this.classList.remove('home-popup--hidden');
    this.setAttribute('open', 'true');
    document.body.classList.add('home-popup-scroll-lock');
  }

  hide(isInitial = false) {
    this.classList.add('home-popup--hidden');
    this.removeAttribute('open');
    document.body.classList.remove('home-popup-scroll-lock');

    if (!isInitial && this.storageKey) {
      const payload = JSON.stringify({ closedAt: Date.now() });
      try {
        window.localStorage.setItem(this.storageKey, payload);
      } catch (error) {
        console.warn('[home-popup] failed to persist state', error);
      }
    }
  }
}

if (!customElements.get('home-popup')) {
  customElements.define('home-popup', HomePopupElement);
}
